var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessibilityBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 407,
    viewBox: "0 0 390 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_170_466)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 43,
    r: 33,
    fill: "url(#paint0_radial_170_466)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.309 262.457C355.442 366.457 248.544 428.176 144.542 400.309C40.5427 372.442 -21.1755 265.543 6.69124 161.543C34.5581 57.5428 141.457 -4.1762 245.458 23.6916C349.458 51.5582 411.175 158.457 383.309 262.457Z",
    fill: "url(#paint1_radial_170_466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_170_466",
    x: 25,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_170_466"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.4999 16) rotate(137.878) scale(63.366 746.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_170_466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.5 375) rotate(-57.6918) scale(391.039 391.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831336,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04875E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityBg);
export default __webpack_public_path__ + "static/media/accessibilityBg.6cb6be5e43be8e97825bf69b825e641c.svg";
export { ForwardRef as ReactComponent };